import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useCallback } from 'react'

import { ProductPriceSyncPage } from '@/components/ProductPriceSync/ProductPriceSyncPage'
import {
  productPriceSyncSearchSchema,
  withoutPriceSyncDefaults,
  type ProductPriceSyncSearch,
} from '@/components/ProductPriceSync/search'
import { inPageSearch, type SearchChangeOptions } from '@/lib/searchNavigation'

/** Wiring only. The schema lives beside the page in `search.ts`. */
export const Route = createFileRoute('/_app/data-vault/product-price-sync')({
  validateSearch: productPriceSyncSearchSchema,
  component: ProductPriceSyncRoute,
})

function ProductPriceSyncRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })
  const onSearchChange = useCallback(
    (next: Partial<ProductPriceSyncSearch>, options?: SearchChangeOptions) =>
      void navigate(inPageSearch(withoutPriceSyncDefaults, next, options)),
    [navigate],
  )
  return <ProductPriceSyncPage search={search} onSearchChange={onSearchChange} />
}
